module.exports = __webpack_public_path__ + "img/unnamed.0f2fbd95.jpg";